enum UserTrackEvent {
  InviteeVisitsRoutingForm = 'invitee_visits_routing_form',
  InviteeSubmitsRoutingForm = 'invitee_submits_routing_form',
  InviteeSchedulingPage = 'invitee_scheduling_page',
  InviteeEventTypePage = 'invitee_event_type_page',
  InviteeSelectDay = 'invitee_select_day',
  InviteeSelectTime = 'invitee_select_time',
  InviteeMeetingScheduled = 'invitee_meeting_scheduled',
}

declare global {
  interface Window {
    fbq: any;
  }
}

export class MetaPixelTracker {
  private static userTrackingId: string;

  static setUserTrackingId(id: string) {
    MetaPixelTracker.userTrackingId = id;
  }

  static inviteeVisitsRoutingForm = () => {
    MetaPixelTracker.fbqEvent(UserTrackEvent.InviteeVisitsRoutingForm);
  };

  static inviteeSubmitsRoutingForm = () => {
    MetaPixelTracker.fbqEvent(UserTrackEvent.InviteeSubmitsRoutingForm);
  };

  static inviteeSchedulingPage = () => {
    MetaPixelTracker.fbqEvent(UserTrackEvent.InviteeSchedulingPage);
  };

  static inviteeEventTypePage = () => {
    MetaPixelTracker.fbqEvent(UserTrackEvent.InviteeEventTypePage);
  };

  static inviteeSelectDay = () => {
    MetaPixelTracker.fbqEvent(UserTrackEvent.InviteeSelectDay);
  };

  static inviteeSelectTime = () => {
    MetaPixelTracker.fbqEvent(UserTrackEvent.InviteeSelectTime);
  };

  static inviteeMeetingScheduled = () => {
    MetaPixelTracker.fbqEvent(UserTrackEvent.InviteeMeetingScheduled);
  };

  private static fbqEvent = async (action: string) => {
    if (!MetaPixelTracker.isConfigured()) return;

    if (typeof window !== 'undefined' && window.fbq) {
      // console.debug(
      //   `window.fbq('trackSingleCustom', '${MetaPixelTracker.userTrackingId}', '${action}')`,
      // );
      window.fbq('init', MetaPixelTracker.userTrackingId);
      window.fbq('trackSingleCustom', MetaPixelTracker.userTrackingId, action);
    }
  };

  private static isConfigured(): boolean {
    return !!MetaPixelTracker.userTrackingId;
  }
}
